import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { riskComplianceBasePath } from './riskCompliancePaths';
import { useRiskComplianceErrorMessage } from './useRiskComplianceErrorMessage';

const BLOCK_ENDPOINTS = {
  companyInfo: 'company-info',
  financialStrength: 'financial-strength',
  hierarchy: 'hierarchy',
  ownership: 'ownership',
};

export const useFetchRiskComplianceBlockHandler = (profileId, blockKey) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const getErrorMessage = useRiskComplianceErrorMessage();
  const endpoint = BLOCK_ENDPOINTS[blockKey];

  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.get(`${riskComplianceBasePath(profileId)}/${endpoint}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers', profileId, 'crif', 'risk-compliance'] });
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
    },
  });
};
